import { ApolloProvider } from '@apollo/client/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from '~/components/ui/sonner'
import { ThemeProvider } from '~/components/ui/theme-provider'
import { router } from '~/routes/router'
import { initTracing } from '~/tracing'
import { TailwindIndicator } from '~/utils/TailwindIndicator'
import { client } from './helpers/apollo'
import './index.css'
import './i18n/i18n'

// Initialize OpenTelemetry tracing
initTracing()

export function Main() {
  return (
    <React.StrictMode>
      <ThemeProvider defaultTheme="system" storageKey="kering-theme">
        <ApolloProvider client={client}>
          <RouterProvider router={router} />
        </ApolloProvider>
        <Toaster />
        <TailwindIndicator />
      </ThemeProvider>
    </React.StrictMode>
  )
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
)
root.render(<Main />)
